import { listEnumNumbers } from "@protobuf-ts/runtime"
import { OrderCreditsBy } from "gen/search/service/service_pb"
import { UseSearchSortRes } from "shared-ts/hooks/useSort"
import { useWebSearchSort } from "shared-web/hooks/useWebSort"

interface UseCreditsTableSortRes extends UseSearchSortRes<OrderCreditsBy> {
  orderBy: OrderCreditsBy
}

export function useCreditsTableSort(): UseCreditsTableSortRes {
  const useSearchSortRes = useWebSearchSort<OrderCreditsBy>({
    items: listEnumNumbers(OrderCreditsBy).filter(
      (o) => o !== OrderCreditsBy.NONE
    ),
    keyExtractor,
    labelExtractor,
  })

  return {
    ...useSearchSortRes,
    orderBy: useSearchSortRes.sortProps.sort?.value ?? OrderCreditsBy.NONE,
  }
}

const keyExtractor = (orderBy: OrderCreditsBy): string => orderBy.toString()

const labelExtractor = (orderBy: OrderCreditsBy): string =>
  ({
    [OrderCreditsBy.NONE]: "",
    [OrderCreditsBy.CREATED_AT]: "Date",
    [OrderCreditsBy.TOTAL_BALANCE]: "Credit",
  })[orderBy]
